import React from "react";
import Moment from "react-moment";
import { PriceHelpers } from "../../helpers/Helpers";
import { PaymentDetailsPhonePe } from "../../model/OrderDetails";
import { User } from "../../user/User";

interface PaymentPhonePeComponentProps {
  paymentDetails: PaymentDetailsPhonePe;
  liu?: User;
}

export class PaymentPhonePeComponent extends React.Component<PaymentPhonePeComponentProps> {
  render() {
    return (
      <>
        <div className="">
          <div className="card-body p-0">
            {this.props.paymentDetails.phonePeOrderId && (
              <div className="col no-gutters align-items-center">
                <span className="font-weight-bold">Order ID : </span>
                <span className="text-xs mb-1">
                  {this.props.paymentDetails.phonePeOrderId}
                </span>
              </div>
            )}
            {this.props.paymentDetails.paymentDate && (
              <div className="col no-gutters align-items-center">
                <span className="font-weight-bold">Payment Date: </span>
                <span className=" text-xs mb-1">
                  <Moment format="DD-MM-YYYY">
                    {this.props.paymentDetails.paymentDate}
                  </Moment>
                </span>
              </div>
            )}
            <div className="col no-gutters align-items-center">
              <span className="font-weight-bold">Payment Status: </span>
              {this.props.paymentDetails.paymentStatus}
            </div>
            <div className="col no-gutters align-items-center">
              <span className="font-weight-bold">Payment Method: </span>

              <span className="text-xs mb-1">
                {this.props.paymentDetails.paymentMethod}
              </span>
            </div>
            {this.props.paymentDetails.paymentPrice && (
              <div className="col no-gutters align-items-center">
                <span className="font-weight-bold">Payment Amount: </span>

                <span className="text-xs mb-1">
                  {PriceHelpers.getDisplayPriceV2(
                    this.props.paymentDetails.paymentPrice
                  )}
                </span>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}
